export enum DiscountType {
    PERCENT = 'PERCENT',
    AMOUNT = 'EXACT_VALUE',
}

export type DiscountInput = {
    amount: number
    type: DiscountType
}
